import React from 'react';
import { ConfigProvider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import RouterOutlet from './RouterOutlet';
import { theme } from 'constants/theme';
import { RootState } from 'store/configureStore';
import { themesList } from 'constants/themesList';
import { ThemeList } from 'store/ducks/globalTypes';
import ThemeSelector from './components/ThemeSelector';
import './constants/translation/i18n';

const App: React.FC = () => {
  const dispatch = useDispatch();
  const { scheme } = useSelector((state: RootState) => state.global);
  // Fallback to deepBlueTheme if current scheme is undefined (commented out theme)
  const currentTheme =
    themesList[scheme as ThemeList] || themesList.deepBlueTheme;
  const currentScheme = themesList[scheme as ThemeList]
    ? scheme
    : ThemeList.DEEP_BLUE_THEME;

  return (
    <ThemeSelector theme={currentScheme as ThemeList}>
      <React.Suspense fallback={<div>Loading</div>}>
        <ConfigProvider theme={theme(currentTheme)}>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <RouterOutlet />
          </QueryParamProvider>
        </ConfigProvider>
      </React.Suspense>
    </ThemeSelector>
  );
};

export default App;
